<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card overflow-hidden">
            <div class="card-body pt-0">
              <div class="p-2 text-center">
                 <div class="user-thumb mb-4 mt-5 text-center">
                    <div class="avatar-md mx-auto">
                        <div class="avatar-title rounded-circle bg-light-primary text-primary h1">
                            <i class="bx bxs-user-circle"></i>
                        </div>
                    </div>
                </div>
                <div v-if="!error">
                    <div class="spinner-border text-primary m-1" role="status">
                        <span class="sr-only">Đang xử lý...</span>
                    </div>
                    <h5 class="font-size-16 mt-3">Đang xác thực từ Portal...</h5>
                    <p class="text-muted">Vui lòng đợi trong giây lát, hệ thống đang tự động đăng nhập.</p>
                </div>
                
                <div v-else class="alert alert-danger">
                    <h5 class="text-danger"><i class="mdi mdi-block-helper me-2"></i> Lỗi đăng nhập</h5>
                    <p>{{ error }}</p>
                    <router-link to="/dang-nhap" class="btn btn-sm btn-primary mt-3">Về trang đăng nhập</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiClient } from "@/state/modules/apiClient";

export default {
  page: {
    title: "Portal SSO",
    meta: [{ name: "description", content: "Login via Portal Ticket" }]
  },
  data() {
    return {
      error: '',
    };
  },
  mounted() {
    this.handlePortalSSO();
  },
  methods: {
    async handlePortalSSO() {
      const ticket = this.$route.query.ticket;
      if (!ticket) {
        this.error = "Không tìm thấy mã xác thực (ticket) từ Portal.";
        return;
      }

      try {
        // Gọi API login qua portal ticket
        const response = await apiClient.post(`Auth/login-portal/${ticket}`);
        
        if (response && response.resultCode === "SUCCESS") {
          const authData = response.data;
          
          // Lưu dữ liệu vào localStorage đồng bộ với logic của auth.vue
          localStorage.setItem('auth-user', JSON.stringify(authData));
          localStorage.setItem('user-token', JSON.stringify(authData.token));
          
          // Quan trọng: Lưu menuItems để sidebar có thể hiển thị
          if (authData.user) {
              const menu = authData.user.menu || authData.user.menuItems;
              if (menu) {
                  localStorage.setItem("menuItems", JSON.stringify(menu));
              }
          }
          
          // Redirect về trang chủ để App khởi tạo lại giao diện với đầy đủ thông tin
          window.location.href = "/";
        } else {
          this.error = response.message || "Xác thực không thành công. Vui lòng thử lại.";
        }
      } catch (e) {
        this.error = "Lỗi kết nối hệ thống: " + (e.message || e.toString());
      }
    },
  },
};
</script>
